import { useEffect, useMemo, useRef, useState } from "react";
import Icon from "../../../components/Icon/Icon";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  sendMemberReminders,
  updateMemberSubscriptionInfo,
  setMemberDetailsVisible,
  fetchCountries,
} from "../../Admin/adminAction";
import { MonthData } from "../../../constants/AdminData";
import Box from "../../../components/Box";
import Label from "../../../components/Label";
import Input from "../../../components/Input";
import ErrorMessage from "../../../components/ErrorMessage";
import { getFormattedTime } from "../../../util/timeUtility";
import styled from "styled-components";
import { showNotification } from "../../../util/Utility";
import DefaultModal from "../../../components/DefaultModal/DefaultModal";
import DisableMemberModal from "./DisableMemberModal";
import truncate from "lodash/truncate";
import moment from "moment";
import dayjs from "dayjs";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { UPDATE_MEMBER_INFO_STATUS_SUCCESS } from "../../Admin/adminActionType";
import { STORE_CITIES } from "../../Admin/adminActionType";
import ProfileModalCitySelection from "../../../components/CustomDropdown/ProfileModalCitySelection";
import { capitalizeFirstLetter } from "../../../util/Utility";
import membershipIcon from "../../../assets/images/membership_icon.svg";
import download from "../../../assets/images/download-white-icon.svg";
import { Modal } from "antd";
import axios from "axios";
import editIcon from "../../../assets/images/Edit.svg";
import bellIcon from "../../../assets/images/Bell.svg";
import CancelIcon from "../../../assets/images/Cancel.svg";
import SaveIcon from "../../../assets/images/save.svg";
import crossIcon from "../../../assets/images/cross 1.svg";
import { OverlayTrigger } from "react-bootstrap";
import info from "../../../assets/images/Info.svg";
import { Popover } from "react-bootstrap";
import { setUser } from "@sentry/react";
import {baseUrl} from '../../../app.config'
import { fetchMemberInfoList } from "../../../redux/UserReducer/userAction";
import { background } from "styled-system";

const countryAbbr = {
  "+31": "NL",
  "+49": "DE",
  "+43": "AT",
  "+33": "FR",
  "+32": "BE",
};



const monthMap = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const NextPaymentDateText = styled.span`
  font-family: Raleway;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: #7e7e7e;
  margin-left: 10px;
`;

const NextPaymentDateWrapper = styled.div`
  margin: 16px 0 0px 0;
`;
const DatePickerBox = styled.div`
  .ant-picker {
    width: 100%;
    height: 54px;
    border: 1px solid #eff0f7;
    box-shadow: 0px 2px 6px #13124212;
    border-radius: 8px;
  }

  .ant-picker-focused {
    border: 1px solid #eff0f7;
    box-shadow: 0px 2px 6px #13124212;
    border-radius: 8px;
  }

  .ant-picker .ant-picker-input > input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #1a1a1a;
  }
`;
const SelectBoxWrapper = styled.span`
  .ant-select-selection-item {
    font-size: 18px;
    font-weight: 500;
    font-family: Raleway;
  }
`;

const customCountries = [
  { label: "Netherlands", value: "Netherlands" },
  { label: "Germany", value: "Germany" },
  { label: "France", value: "France" },
  { label: "Austria", value: "Austria" },
  { label: "Belgium", value: "Belgium" },
];

const ProfileModal = ({ onHide, refetchCustomerList }) => {
  const dispatch = useDispatch();
  const [isActiveEdit, setIsActiveEdit] = useState(true);
  const [isDisable, setIsDisable] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [activeMemberDetails, setActiveMemberDetails] = useState(null);
  const [errors, setErrors] = useState({});
  const [historyPageNum, setHistoryPageNum] = useState(1);
  const [historyPageSize, setHistoryPageSize] = useState(2);
  const isFetchingCities = useSelector(
    (state) => state.adminReducer.isFetchingCities
  );
  const countries = useSelector((state) => state.adminReducer.countries);
  const cities = useSelector((state) => state.adminReducer.cities);
  const activeEntity = useSelector((state) => state.appReducer.activeEntity);
  const agent = useSelector((state) => state.appReducer.user);
  const activeMember = useSelector((state) => state.adminReducer.activeMember);
  const [isFocusedIBANOne, setIsFocusedIBANOne] = useState(false);
  const [isFocusedIBANTwo, setIsFocusedIBANTwo] = useState(false);
  const [isFocusedCustName, setIsFocusedCustName] = useState(false);
  const [isDetailsUpdated, setIsDetailsUpdated] = useState(false);
  const total_reminder_count = useSelector(
    (state) => state.userReducer.memberDetails?.total_reminder_count
  );
  const user = useSelector((state) => state.appReducer?.user);

  const memberPlans = useSelector((state) => state.adminReducer.memberPlans);
  const plan_list = memberPlans?.planList;
  const pages = useSelector((state) => state?.appReducer?.pages);
  const userType = localStorage.getItem("user_type");
  const reminder_history = useSelector(
    (state) => state.userReducer.memberInfo?.reminder_history
  );

  const [components, setComponents] = useState([]);
  const [compareIban, setCompareIban] = useState("");
  const [isCompareIbanError, setIsCompareIbanError] = useState(false);
  const [showChangeSub, setShowChangeSub] = useState(false);
  const [isPaymentModeChanged, setIsPaymentModeChanged] = useState(false);
  const [isAccountNameChanged, setIsAccountNameChanged] = useState(false);
  const [isIbanChanged, setIsIbanChanged] = useState(false);
  const [comment, setComment] = useState("");
  const showLoadMoreButton = Math.ceil(total_reminder_count / historyPageSize);
  const [missedMonths, setMissedMonths] = useState([]);
  const [missedPayments, setMissedPayments] = useState([]);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [showMarkModal, setShowMarkModal] = useState(false);
  const [missedAmountMap, setMissedAmountMap] = useState({});
  const [selectedMissedTotal, setSelectedMissedTotal] = useState(0);
  const [ibanError, setIbanError] = useState("");
  const [membershipError, setMembershipError] = useState("");
  const userRef = useRef(null);
  const { t } = useTranslation();
  const [acknowledgeEditSubscription, setAcknowledgeEditSubscription] =
    useState(false);
  const [isEditPersonDetails, setIsEditPersonDetails] = useState(true);
  const [isEditMarkPayment, setIsEditMarkPayment] = useState(true);
  const [editSubscriptionErrors, setEditSubscriptionErrors] = useState({});
  const [users, setUsers] = useState({ fname: "", lname: "", contact_name: "" });
  const [isDeleteMember, setIsDeleteMember] = useState(false)
  const [isDeletingMember, setIsDeletingMember] = useState(false)
  const [isDisableMessageModal, setIsDisableMessageModal] = useState(false);
  const [disableMessage, setDisableMessage] = useState("");

  const handleFocusOne = () => {
    setIsFocusedIBANOne((prev) => !prev);
  };
  const handleFocusTwo = () => {
    setIsFocusedIBANTwo((prev) => !prev);
  };
  const handleFocusCustName = () => {
    setIsFocusedCustName((prev) => !prev);
  };
  const handleBlurCustName = () => {
    setIsFocusedCustName(false);
  };
  // const handleBlur = () => {
  //     setIsFocusedIBAN(false);
  // }
  const financesComponent = useMemo(() => {
    return pages?.find((page) => page?.label === "member_info");
  }, [pages]);

  useEffect(() => {
    if (financesComponent) {
      setComponents(financesComponent);
    }
  }, [financesComponent]);

  useEffect(() => {
    if (activeMember) {
      userRef.current = activeMember;
      setActiveMemberDetails({ ...activeMember });
      setCompareIban(activeMember?.customerIBAN);
      // setIsDisable(activeMember.isDeactivated)
      const mp = activeMember.payments?.filter(
        (payment) => payment.status === "MISSED"
      );
      console.log("MISSED PAYMENTS :", mp);
      setMissedPayments(mp);
      const mm = [];
      const missedAmt = {};
      mp.forEach((p) => {
        if (p.paymentCard) {
          if (activeMember?.activeSubscription?.recurring_type === "monthly") {
            const mul =
              Math.round(
                p.paymentCard.amount / activeMember.activeSubscription?.amount
              ) || 0;
            if (
              mul > 1 &&
              !mm.includes(`January - ${monthMap[p.paymentCard.month]}`)
            ) {
              mm.push(`January - ${monthMap[p.paymentCard.month]}`);
              missedAmt[`January - ${monthMap[p.paymentCard.month]}`] =
                p.paymentCard.amount;
            } else if (
              mul === 1 &&
              !mm.includes(`${monthMap[p.paymentCard.month]}`)
            ) {
              mm.push(monthMap[p.paymentCard.month]);
              missedAmt[monthMap[p.paymentCard.month]] = p.paymentCard.amount;
            }
          } else if (
            activeMember?.activeSubscription?.recurring_type === "yearly"
          ) {

            // for yearly sub with full year charge
            if (
              p.paymentCard.amount == activeMember.activeSubscription?.amount &&
              !mm.includes(`January - December`)
            ) {
              mm.push(`January - December`);
              missedAmt[`January - December`] = p.paymentCard.amount;
              console.log("full year ********************");
            } else if (
              p.paymentCard.amount != activeMember.activeSubscription?.amount &&
              !mm.includes(`${monthMap[p.paymentCard.month]} - December`)
            )
              mm.push(`${monthMap[p.paymentCard.month]} - December`);
            missedAmt[`${monthMap[p.paymentCard.month]} - December`] =
              p.paymentCard.amount;
          }
        } else {
          mm.push(monthMap[p.month]);
          missedAmt[monthMap[p.month]] = p.amount;
        }
      });
      // if(activeMember?.activeSubscription?.recurring_type === "yearly"){
      //   setSelectedMonths(['January - December'])
      //   missedAmt['January - December'] = mp[0]?.paymentCard?.amount || 0;
      // }
      setMissedAmountMap(missedAmt);
      setMissedMonths(mm);
    }
  }, [activeMember]);
  useEffect(() => {
    dispatch(fetchCountries());
  }, []);

  useEffect(() => {
    if (activeEntity?._id) {
      dispatch(
        fetchMemberInfoList({
          entity_id: activeEntity?._id,
          member_id: activeMember?._id,
          pageSize: 30,
          pageNum: 1,
        })
      );
    }
  }, [dispatch, activeEntity]);
  const optionsPlan = () => {
    let listValues = [];
    if (plan_list?.length) {
      plan_list.forEach((plan) => {
        if (plan.isFree) {
          // Check for a 'isFree' property in the plan object
          // Don't push the free plan to listValues
          return;
        }
        listValues.push({
          ...plan,
          label: `${plan?.plan_name} - € ${plan.amount}`,
          value: plan._id,
        });
      });
    }
    listValues.unshift({
      label: t("Free Subscription"),
      value: null, //
    });
    return listValues;
  };
  const getPaymentMethods = () => {
    let methods = [
      {
        label: t("Free Subscription"),
        value: null,
      },
      {
        label: t("Auto Pay"),
        value: "automatic",
      },
      {
        label: t("Manual Pay"),
        value: "manual",
      },
    ];

    return methods;
  };
  const renderPaymentStatus = (item, month) => {
    const filteredData = item?.payments?.filter(
      (payment) => payment.month === month
    );
    if (filteredData?.length > 0) {
      return filteredData.map((payment) => {
        let color = "";
        switch (payment.status) {
          case "FAILED":
            color = "red-color";
            break;
          case "MISSED":
            color = "red-color";
            break;
          case "PENDING":
            color = "orange-color";
            break;
          case "PROCESSING":
            color = "yellow-color";
            break;
          case "SUCCESS":
            color = "green-color";
            break;
          default:
            break;
        }

        if (payment.isOfflineUpdate && payment.status === "SUCCESS") {
          color = "#6FA8DC";
        }

        return (
          <div key={month} style={{ display: "flex" }}>
            {filteredData.map((payment) => (
              <Box
                key={payment._id}
                className={color}
                top="5px"
                left="5px"
                position="relative"
              />
            ))}
          </div>
        );
      });
    } else {
      return <Box ml="7px">{"-"}</Box>;
    }
  };
  const handleToggleChange = () => {
    const hasProcessing = activeMemberDetails?.payments?.some(
      sub => sub.status?.toUpperCase() === "PROCESSING"
    );
    if (hasProcessing) {
      setDisableMessage("Members with a processing payment status cannot be disabled");
      setIsDisableMessageModal(true); // member defualt modal at last
      return;
    }
  
    // If no PROCESSING status, proceed with the disable member
    disableMember();
  };
  const disableMember = () => {
    setIsDisable((prevState) => !prevState);
  };

  const updateStatus = () => {
    const update = {};
    update._id = activeMemberDetails?._id;
    update.entityId = activeMemberDetails?.subscriptions?.[0]?.entityId;
    update.comment = comment;
    update.agentId = agent._id;
    if (!activeMemberDetails?.isDeactivated) {
      update.status = "INACTIVE";
      dispatch(
        updateMemberSubscriptionInfo(
          activeMemberDetails?._id,
          update,
          true,
          refetchCustomerList,
          t
        )
      ).then(() => {
        // Redirect after successful submission
        window.location.href = `/user/members`;
      });
    } else if (activeMemberDetails?.isDeactivated) {
      update.status = "ACTIVE";
      dispatch(
        updateMemberSubscriptionInfo(
          activeMemberDetails?._id,
          update,
          true,
          refetchCustomerList,
          t
        )
      ).then(() => {
        // Redirect after successful submission
        window.location.href = `/user/members`;
      });
    }
    setIsDisable(false);
  };

  useEffect(() => {
    // console.log(activeMemberDetails?.subscription_plan_id, optionsPlan()[0].value);
    if (!activeMemberDetails?.subscriptions?.[0]?.subscriptionId) {
      const subs = activeMember?.subscriptions.find(
        (sub) => sub.status === "ACTIVE"
      );
      setActiveMemberDetails((prevDetails) => ({
        ...prevDetails,
        subscription_plan_id: subs?.subscriptionId,
      }));
    }
  }, [activeMemberDetails?.subscriptions?.[0]?.subscriptionId]);

  const handleUpdateDetails = (keyName, keyValue) => {
    setIsDetailsUpdated(true);
    if (keyName === "customerAccountName") setIsAccountNameChanged(true);
    if (keyName === "customerIBAN") setIsIbanChanged(true);
    setErrors({});
    setEditSubscriptionErrors({});
    setIsNext(true);
    if (isActiveEdit) {
      let errors = {};
      if (keyName === "fname" || keyName === "lname") {
        const updatedUsers = {
          ...users,
          [keyName]: keyValue,
        };
        setUsers(updatedUsers);
        if (updatedUsers.fname?.includes(",")) {
          errors.fname = "Comma is not allowed";
        }
        if (updatedUsers.lname?.includes(",")) {
          errors.lname = "Comma is not allowed";
        }
        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
        }
        const fullName = `${updatedUsers.fname}, ${updatedUsers.lname}`.trim();
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          name: fullName,
        }));
        return; // exit to prevent falling through to other blocks
      } else if (keyName === "contact_phone") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          phoneNumber: keyValue,
        }));
      } else if (keyName === "country_code") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          countryCode: keyValue,
        }));
      } else if (keyName === "contact_email") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          emailAddress: keyValue,
        }));
      } else if (keyName === "country") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          country: keyValue,
          city: "",
        }));
      } else if (keyName === "dob") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          dob: keyValue,
        }));
      } else if (keyName === "gender") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          gender: keyValue,
        }));
      } else if (keyName === "subscription_plan_id") {
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          subscription_plan_id: keyValue,
        }));
      } else if (keyName === "paymentMode") {
        setIsPaymentModeChanged(true);
        if (keyValue === null) {
          setActiveMemberDetails((prevDetails) => ({
            ...prevDetails,
            paymentMode: keyValue,
          }));
        } else if (keyName === "customerIBAN") {
          setIsIbanChanged(true);
          setActiveMemberDetails((prevDetails) => ({
            ...prevDetails,
            customerIBAN: keyValue,
          }));
        } else if (keyName === "customerAccountName") {
          setIsAccountNameChanged(true);
          setActiveMemberDetails((prevDetails) => ({
            ...prevDetails,
            customerAccountName: keyValue,
          }));
        } else if (keyName === "pincode") {
          setActiveMemberDetails((prevDetails) => ({
            ...prevDetails,
            pincode: keyValue,
          }));
        } else if (keyName === "address") {
          setActiveMemberDetails((prevDetails) => ({
            ...prevDetails,
            address: keyValue,
          }));
        } else {
          setActiveMemberDetails((prevDetails) => ({
            ...prevDetails,
            paymentMode: keyValue,
          }));
        }
      } else {
        // Otherwise, update the field normally
        setActiveMemberDetails((prevDetails) => ({
          ...prevDetails,
          [keyName]: keyValue,
        }));
      }
    }
  };
  // console.log('subscription_plan_id', activeMemberDetails?.subscription_plan_id);
  const showMemberDetails = (item, val = true) => {
    dispatch(setMemberDetailsVisible(item, val));
    window.location.href = `/mosque/${activeEntity?._id}/members/${activeMember?._id}/edit`;
  };

  /*const handleChange = (keyName, keyValue) => {
        setErrors({});
        setIsNext(true);
        const data = {...activeMemberDetails};
        data[keyName] = keyValue;
        setActiveMemberDetails(data);
    }*/

  const emailRegex = /^\S+@\S+\.\S+$/;

  const handleValidation = () => {
    let isValid = true;
    let errors = {};
    console.log("INSIDE VALIDAITION");

    // Validation for name
    if (!users.fname || users?.fname.trim() === "") {
      isValid = false;
      errors.fname = "First Name is required";
    }
    if (!users.lname || users?.lname.trim() === "") {
      isValid = false;
      errors.lname = "Last Name is required";
    }
    if (users.fname?.includes(",")) {
      isValid = false;
      errors.fname = "Comma is not allowed";
    }
    if (users.lname?.includes(",")) {
      isValid = false;
      errors.lname = "Comma is not allowed";
    }

    // Validation for emailAddress
    if (
      activeMemberDetails?.emailAddress &&
      !emailRegex.test(activeMemberDetails?.emailAddress)
    ) {
      isValid = false;
      errors.emailAddress = "Invalid email address";
    }

    // Validation for countryCode
    if (
      !activeMemberDetails?.countryCode ||
      activeMemberDetails?.countryCode.trim() === ""
    ) {
      isValid = false;
      errors.countryCode = "Country code is required";
    }

    // Validation for phoneNumber
    if (
      !activeMemberDetails?.phoneNumber ||
      activeMemberDetails?.phoneNumber.trim() === ""
    ) {
      isValid = false;
      errors.phoneNumber = "Phone number is required";
    }
    if (
      activeMemberDetails?.phoneNumber &&
      (activeMemberDetails?.phoneNumber.length < 4 ||
        activeMemberDetails?.phoneNumber.length > 13)
    ) {
      isValid = false;
      errors.phoneNumber = "Please enter a valid phone number";
    }
    // Validation for country
    if (
      !activeMemberDetails?.country ||
      activeMemberDetails?.country.trim() === ""
    ) {
      isValid = false;
      errors.country = "Country is required";
    }

    // Validation for contact_city
    if (!activeMemberDetails?.city || activeMemberDetails?.city.trim() === "") {
      isValid = false;
      errors.city = "City is required";
    }

    return {
      isValid,
      errors,
    };
  };

  const handleSubmit = () => {
    setErrors({});
    let validate = handleValidation();
    if (validate.isValid) {
      setIsActiveEdit(false);
      if (activeMemberDetails) {
        activeMemberDetails.entityId =
          activeMemberDetails?.subscriptions?.[0]?.entityId || activeEntity._id;
        dispatch(
          updateMemberSubscriptionInfo(
            activeMemberDetails?._id,
            activeMemberDetails,
            false,
            refetchCustomerList,
            t
          )
        );
        setIsActiveEdit(true);
        setIsEditPersonDetails(true);
      }
    } else {
      setErrors(validate.errors);
    }
  };

  const sendReminder = async () => {
    let members = [];
    members.push(activeMember?._id);
    if (members.length > 0) {
      dispatch(
        sendMemberReminders({
          entity_id: activeEntity?._id,
          activeMember: activeMember,
          members,
          isProfileModal: true,
          pageNum: historyPageNum,
          pageSize: historyPageSize,
        })
      );
    } else {
      showNotification("error", "Please Select Users");
    }
  };

  const getIfCurrentPaymentIsPending = (payment_history) => {
    if (payment_history && payment_history.length > 0) {
      let start_of_month = moment().startOf("month");
      let end_of_month = moment().endOf("month");
      let filtered_data = payment_history.filter(
        (item) =>
          item.payment_status !== "paid" &&
          moment(new Date(item.payment_due_date)).isBetween(
            start_of_month,
            end_of_month
          )
      );
      if (filtered_data && filtered_data.length) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const shouldDisableSubChangeBtn = () => {
    if (activeMemberDetails?.paymentMode === "automatic") {
      if (
        !activeMemberDetails?.customerAccountName ||
        !activeMemberDetails?.customerIBAN
      )
        return true;
    }
    if (acknowledgeEditSubscription === false) {
      return true;
    }
    return false;
  };

  const getNextPaymentDate = () => {
    const date = new Date();
    const day = date.getDate();
    let nextMonth = date.getMonth() + (day > 1 ? 2 : 1);
    let year = date.getFullYear();
    if (nextMonth > 12) {
      nextMonth = 1;
      year += 1;
    }
    const formattedMonth = nextMonth < 10 ? `0${nextMonth}` : nextMonth;
    return activeMember?.activeSubscription?.recurring_type === "yearly"
      ? `${year + 1}`
      : `01/${formattedMonth}/${year}`;
  };
  const formattedMembershipDate =
    activeMemberDetails?.subscriptions &&
    activeMemberDetails.subscriptions.length > 0
      ? getFormattedTime(
          activeMemberDetails.subscriptions[0].date,
          "DD MMM YYYY, hh:mm a"
        )
      : "-";
  // console.log("customer name : ", activeMemberDetails?.customerAccountName);
  // console.log("customer IBAN : ", activeMemberDetails?.customerIBAN);
  console.log("activeMemberDetails",activeMemberDetails);
  const getSelectedPlan = (id) => {
    console.log("plan list",plan_list);
    
    return plan_list.find((plan) => plan._id === id);
  };

  const getSubscriptionDate = () => {
    const subscription = activeMemberDetails?.subscriptions.find(
      (item) => item.status === "ACTIVE"
    );
    return subscription?.date || null;
  };

  const infoPopover = (
    <Popover id="popover-basic" style={{ boxShadow: "#0C0C0D0D" }}>
      <Popover.Body
        style={{
          padding: "10px",
          color: "#1A1A1A",
          maxWidth: "250px",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        {t("Membership Last modified on")}
        <p className="m-0">
          {t(getFormattedTime(getSubscriptionDate(), "DD MM YYYY"))}
        </p>
      </Popover.Body>
    </Popover>
  );
  const handleSubscriptionValidation = () => {
    let isValid = true;
    let errors = {};
    if (acknowledgeEditSubscription === false) {
      isValid = false;
      errors.editSubscriptionAcknowledge =
        "Please select this to acknowledge the user";
    }
    if (
      activeMemberDetails?.paymentMode === "automatic" &&
      !activeMemberDetails?.customerAccountName
    ) {
      isValid = false;
      errors.customerAccountName = "Please enter the account holder's name";
    }
    if (
      activeMemberDetails?.paymentMode === "automatic" &&
      !activeMemberDetails?.customerIBAN
    ) {
      isValid = false;
      errors.customerIBAN = "Please enter the user's IBAN";
    }
    if (
      activeMemberDetails?.subscription_plan_id !== null &&
      activeMemberDetails?.paymentMode === null
    ) {
      isValid = false;
      errors.paymentMode = "Please select payment a manual or automatic method";
    }
    if (
      activeMemberDetails?.paymentMode &&
      !activeMemberDetails?.subscription_plan_id
    ) {
      isValid = false;
      errors.subscription_plan_id = "Please select a membership";
    }
    if (
      activeMemberDetails?.paymentMode === "automatic" &&
      activeMemberDetails?.customerIBAN
    ) {
      let error = validateIBAN(activeMemberDetails?.customerIBAN);
      console.log("iban error is ", error);
      if (error) {
        isValid = false;
        setIbanError(error);
      } else {
        setIbanError("");
        if (
          activeMemberDetails?.paymentMode === "automatic" &&
          activeMemberDetails?.customerIBAN !== compareIban
        ) {
          isValid = false;
          setIsCompareIbanError(true);
        }
      }
    }
    return {
      isValid,
      errors,
      acknowledgeEditSubscription,
    };
  };
  const handleChangeSubscription = async () => {
      let data = {};
    if (activeMemberDetails?.paymentMode !== userRef?.current.paymentMode) {
      if (activeMemberDetails?.paymentMode === "automatic") {
        data.entityId = activeMemberDetails?.subscriptions[0]?.entityId;
        data.subscriptionId = activeMemberDetails?.subscription_plan_id;
        data.customerIBAN = activeMemberDetails?.customerIBAN;
        data.customerAccountName = activeMemberDetails?.customerAccountName;
        data.paymentMode = activeMemberDetails?.paymentMode;
      } else if (activeMemberDetails?.paymentMode === "manual") {
        data.entityId = activeMemberDetails?.subscriptions[0]?.entityId;
        data.subscriptionId = activeMemberDetails?.subscription_plan_id;
        data.customerIBAN = null;
        data.customerAccountName = null;
        data.paymentMode = activeMemberDetails?.paymentMode;
        console.log("data before updating manual", data);
      } else {
        data.paymentMode = null;
        data.entityId = activeMemberDetails?.subscriptions[0]?.entityId;
        data.subscriptionId = activeMemberDetails?.subscription_plan_id;
      }
    } else {
      if (activeMemberDetails?.paymentMode === "automatic") {
        data.customerAccountName = activeMemberDetails?.customerAccountName;
        data.customerIBAN = activeMemberDetails?.customerIBAN;
        data.entityId = activeMemberDetails?.subscriptions[0]?.entityId;
        data.subscriptionId = activeMemberDetails?.subscription_plan_id;
        data.paymentMode = activeMemberDetails?.paymentMode;
      } else if (activeMemberDetails?.paymentMode === "manual") {
        data.entityId = activeMemberDetails?.subscriptions[0]?.entityId;
        data.subscriptionId = activeMemberDetails?.subscription_plan_id;
        data.customerIBAN = null;
        data.customerAccountName = null;
        data.paymentMode = activeMemberDetails?.paymentMode;
      } else {
        data.paymentMode = null;
        data.entityId = activeMemberDetails?.subscriptions[0]?.entityId;
        data.subscriptionId = activeMemberDetails?.subscription_plan_id;
      }
    }
    try {
      setEditSubscriptionErrors({});
      let validate = handleSubscriptionValidation();
      if (validate.isValid) {
        setIsActiveEdit(false);
        if (activeMemberDetails?.paymentMode !== userRef?.current.paymentMode) {
          if (activeMemberDetails?.paymentMode === "automatic") {
            if (
              userRef?.current?.subscription_plan_id !==
              activeMemberDetails.subscription_plan_id
            ) {
              showNotification(
                "success",
                t("All changes will be reflected from next month's payment")
              );
            }
          } else if (activeMemberDetails?.paymentMode === "manual") {
            if (
              userRef?.current?.subscription_plan_id !==
              activeMemberDetails.subscription_plan_id
            ) {
              showNotification(
                "success",
                t("All changes will be reflected from next month's payment")
              );
            }
          }
        } else {
          if (
            activeMemberDetails?.paymentMode === "automatic" ||
            activeMemberDetails?.paymentMode === "manual"
          ) {
            if (
              userRef?.current?.activeSubscription._id !==
              activeMemberDetails.subscription_plan_id
            ) {
              showNotification(
                "success",
                t("All changes will be reflected from next month's payment")
              );
            }
          }
        }
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}member/${activeMemberDetails?._id}/modify-subscription`,
          {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        );
        if (res.status === 200) {
          const json = await res.json();
          console.log("data of the member after updating-->", data);
          console.log("after ->", activeMemberDetails);
          refetchCustomerList();
          dispatch({
            type: UPDATE_MEMBER_INFO_STATUS_SUCCESS,
            details: json?.data,
            isFetching: false,
            isDisable: isDisable,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          setIsActiveEdit(true);
        }
      } else {
        setEditSubscriptionErrors(validate.errors);
      }
    } catch (error) {
      console.log(error);
      showNotification("error", "error changing subscription");
    }
  };
  // console.log("active memever details --------------___>", activeMemberDetails);

  // console.log("shoudl Disable", shouldDisableSubChangeBtn());
  const formattedName = ({ type, isFirstName }) => {
    if (!activeMemberDetails?.name) return "NA";

    const nameParts = activeMemberDetails.name.split(","); // Split by comma
    if (type === "input") {
      if (nameParts.length > 1) {
        users.fname = nameParts[0].trim();
        users.lname = nameParts[1].trim();
      }
    } else {
      users.contact_name = `${nameParts[1].trim()}, ${nameParts[0].trim()}`; // lname, fname → fname lname
    }
    // console.log("fname :", users.fname, "lname :", users.lname);
    return type === "input"
      ? isFirstName
        ? users.fname
        : users.lname
      : type === "no-truncate"
      ? users.contact_name
      : truncate(users.contact_name, {
          length: user?.role === "admin" ? 20 : 30,
        }); // Truncate to 15 characters
  };

  const handleCheckboxChange = (month) => {
    setSelectedMonths((prev) =>
      prev.includes(month) ? prev.filter((m) => m !== month) : [...prev, month]
    );
  };

  const handleMarkPaid = async () => {
    try {
      setShowMarkModal(false);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}admin/mark-paid?userId=${activeMemberDetails._id}`,
        {
          missedMonthsToMark: selectedMonths,
        }
      );
      if (res.status === 200) {
        showNotification("success", "Status updated");
        window.location.reload();
      }
    } catch (error) {
      showNotification("error", "Status update failed");
    }
  };

  useEffect(() => {
    let sum = 0;
    selectedMonths?.forEach((sm) => {
      sum += missedAmountMap[sm];
    });
    setSelectedMissedTotal(sum);
  }, [selectedMonths]);

 const formatDobForInput = (dob) => {
  if (!dob) return '';
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (isoDateRegex.test(dob)) return dob;
  const [day, month, year] = dob.split('-');
  return `${year}-${month}-${day}`;
};


 const validateIBAN = (iban) => {
  const errors = [];
  const ibanTrimmed = iban.trim().toUpperCase();
  const isNetherlands = ibanTrimmed.startsWith("NL");
  const isBelgium = ibanTrimmed.startsWith("BE");
  const isGermany = ibanTrimmed.startsWith("DE");

    // Check starts with "NL, BE, DE"
    if (!isNetherlands && !isBelgium && !isGermany) {
      errors.push("IBAN only valid for Netherlands, Belgium, Germany");
    }
    if (isNetherlands) {
      // Check overall length for NL
      if (ibanTrimmed.length !== 18) {
        errors.push("IBAN must be exactly 18 characters long for Netherlands");
      } else {
        // Next 2 characters should be numbers
        const digitsAfterNL = ibanTrimmed.substring(2, 4);
        if (!/^\d{2}$/.test(digitsAfterNL)) {
          errors.push("Invalid IBAN");
        }
        // Next 4 characters should be alphabets
        const bankCodeNL = ibanTrimmed.substring(4, 8);
        if (!/^[A-Za-z]{4}$/.test(bankCodeNL)) {
          errors.push("Invalid IBAN");
        }
        // Next 10 characters should be numbers
        const accountNumberNL = ibanTrimmed.substring(8);
        if (!/^\d{10}$/.test(accountNumberNL)) {
          errors.push("Invalid IBAN");
        }
      }
    }
    if (isBelgium) {
      if (ibanTrimmed.length !== 16) {
        errors.push("IBAN must be exactly 16 characters long for Belgium");
      } else {
        const digitsAfterBE = ibanTrimmed.substring(2, 4);
        if (!/^\d{2}$/.test(digitsAfterBE)) {
          errors.push("Invalid IBAN");
        }
        const accountNumberBE = ibanTrimmed.substring(4);
        if (!/^\d{12}$/.test(accountNumberBE)) {
          errors.push("Invalid IBAN");
        }
      }
    }
    if (isGermany) {
      if (ibanTrimmed.length !== 22) {
        errors.push("IBAN must be exactly 22 characters long for Germany");
      } else {
        const digitsAfterDE = ibanTrimmed.substring(2);
        if (!/^\d{20}$/.test(digitsAfterDE)) {
          errors.push("Invalid IBAN");
        }
      }

      // const bankCodeDE = ibanTrimmed.substring(4, 12);
      // if (!/^\d{8}$/.test(bankCodeDE)) {
      //   errors.push("Characters 5 to 8 must be numbers.");
      // }
      // const accountNumberDE = ibanTrimmed.substring(12);
      // if (!/^\d{10}$/.test(accountNumberDE)) {
      //   errors.push("Characters 9 to 22 must be numbers.");
      // }
    }

  return errors.length > 0 ? errors : null;
};

const handleDeleteMember = async ()=>{
  try {
    const data = {
        reason: comment,
        userId: activeMemberDetails?._id,
        actionType: 'DELETE_USER',
      };
    const activeSub = activeMemberDetails?.subscriptions?.find(sub => sub.status === 'ACTIVE');
    data.entityId = activeSub.entityId;
    setIsDeletingMember(true)
    const res = await axios.post(`${baseUrl}/v1/delete-user-account`, { data, userId: activeMemberDetails?._id, deletedBy: "admin" });
    if(res.status === 200){
      setIsDeletingMember(false)
      showNotification('success','Member Deleted Successfully')
      window.location.reload()
    }
  } catch (error) {
    showNotification('error','Some error occured')
    setIsDeleteMember(false)
    setIsDeletingMember(false)
  }
}

  return (
    <Box>
      <Box>
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-baseline">
              <h4
                style={{ cursor: "default" }}
                title={activeMemberDetails?.name || "NA"}
                onMouseOver={(e) =>
                  (e.target.title = formattedName({ type: "no-truncate" }))
                }
                onMouseOut={(e) =>
                  (e.target.title = activeMemberDetails?.name
                    ? truncate(activeMemberDetails?.name, { length: 20 })
                    : "NA")
                }
              >
                {formattedName({ type: "title" })}
              </h4>
              {components?.canDisableMember && (
                <div>
                  <label
                    className="switch"
                    title={
                      activeMemberDetails?.subscriptions?.[0]?.status
                        ? "Disable user"
                        : "Enable user"
                    }
                  >
                    <input
                      type="checkbox"
                      onChange={handleToggleChange}
                      placeholder={t("disable member")}
                      checked={!activeMemberDetails?.isDeactivated}
                      //disabled={!isActiveEdit}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              )}
              {components?.canDisableMember && (
                <Label style={{ marginLeft: "15px" }}>
                  <p className="user-label">
                    {activeMemberDetails?.isDeactivated
                      ? t("Enable user")
                      : t("Disable user")}
                  </p>
                </Label>
              )}
              {activeMemberDetails?.isMobileOnBoarded ? null : (
                <div className="" style={{ maxWidth: "80%" }}>
                  {/* <Button
                    bg={isActiveEdit ? "#CCCCCC" : "#D0004B"}
                    text="Bewerken"
                    borderRadius="66px"
                    textColor="#FFFFFF"
                    width="40%"
                    ml="20px"
                    onClick={() => showMemberDetails(activeMember, false)}
                    disabled={activeMemberDetails?.isMobileOnBoarded}
                  /> */}
                  {/*<span style={{color: "#D0004B"}}>{isActiveEdit ? "Cancel" : "Edit"}</span>*/}
                </div>
              )}
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            title="Close"
            onClick={() => onHide(null, false)}
          >
            <img src={crossIcon} alt="cross" />
          </div>
        </div>
        <div className="payment-small-details d-flex">
          {!activeMemberDetails?.isMobileOnBoarded && (
            <small
              style={{
                color: "#5D4037",
                background: "#EFECEB",
                borderRadius: "4px",
                padding: "2px 4px",
                marginRight: "8px",
              }}
            >
              {t("Offline")}
            </small>
          )}
          {activeMemberDetails?.activeSubscription?.recurring_type &&
            activeMemberDetails?.paymentMode && (
              <small
                style={{
                  color:
                    activeMemberDetails?.activeSubscription?.recurring_type ===
                    "yearly"
                      ? "#FF5722"
                      : activeMemberDetails?.activeSubscription
                          ?.recurring_type === "monthly"
                      ? "#4763E4"
                      : "",
                  background:
                    activeMemberDetails?.activeSubscription?.recurring_type ===
                    "yearly"
                      ? "#FFEFE9"
                      : activeMemberDetails?.activeSubscription
                          ?.recurring_type === "monthly"
                      ? "#E3F2FD"
                      : "",
                  borderRadius: "4px",
                  padding: "2px 4px",
                  marginRight: "8px",
                }}
              >
                {capitalizeFirstLetter(
                  activeMemberDetails?.activeSubscription?.recurring_type
                )}
              </small>
            )}
          {activeMemberDetails?.paymentMode && (
            <small
              style={{
                color:
                  activeMemberDetails?.paymentMode === "manual"
                    ? "#673AB7"
                    : activeMemberDetails?.paymentMode === "automatic"
                    ? "#00AC4F"
                    : "",
                background:
                  activeMemberDetails?.paymentMode === "manual"
                    ? "#F2E9FE"
                    : activeMemberDetails?.paymentMode === "automatic"
                    ? "#E5F7ED"
                    : "",
                borderRadius: "4px",
                padding: "2px 4px",
                marginRight: "8px",
              }}
            >
              {activeMemberDetails?.paymentMode === "manual"
                ? t("Manual")
                : null}
              {activeMemberDetails?.paymentMode === "automatic"
                ? t("Automatic")
                : null}
            </small>
          )}
          {activeMemberDetails?.paymentMode === null && (
            <small
              style={{
                color: "#D81B60",
                background: "#FCE9F0",
                borderRadius: "4px",
                padding: "2px 4px",
                marginRight: "8px",
              }}
            >
              {t("Free")}
            </small>
          )}
        </div>
        {activeMemberDetails?.paymentMode !== null && (
          <NextPaymentDateWrapper>
            <img src={bellIcon} alt="bell-icon" />
            <NextPaymentDateText>
              {t("Payment Date")}:{" "}
              <span className="black-text-m">{getNextPaymentDate()}</span>
            </NextPaymentDateText>
          </NextPaymentDateWrapper>
        )}
      </Box>
      <Box className="profile-scroll member-deatil-button pt-3">
        <Box
          className="details-card"
          style={{
            pointerEvents:
              activeMemberDetails?.isDeactivated
                ? "none"
                : "",
          }}
        >
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <Icon iconName="user" mr="8px" />
              <h5>{t("Personal Details")}</h5>
            </div>
            <Box
              mb="25px"
              className="d-flex justify-content-between member_ship"
            >
              {user?.role === "product_owner" ? (
                <>
                  <Label color="#7E7E7E" mb="8px">
                    {t("Membership Since")}
                  </Label>
                  <Box style={{ fontWeight: "600", fontSize: "16px" }}>
                    {formattedMembershipDate}
                  </Box>
                </>
              ) : (
                ""
              )}
            </Box>
            <div onClick={() => setIsEditPersonDetails(false)}>
              {isEditPersonDetails && components?.canEditMember && (
                <div className="d-flex gap-1 align-items-center justify-content-center cursor-pointer">
                  <img src={editIcon} className="mb-3" alt="icon" />
                  <p className="edit-details">{t("Edit")}</p>
                </div>
              )}
            </div>
            {!isEditPersonDetails && (
              <div className="d-flex gap-3 align-items-center justify-content-center">
                <div
                  className="d-flex gap-2 mx-3 align-items-center justify-content-center cursor-pointer"
                  onClick={() => {
                    setIsEditPersonDetails(true);
                    setActiveMemberDetails(activeMember);
                  }}
                >
                  <img src={CancelIcon} className="mb-3" alt="icon" />
                  <p className="cancel-details">{t("Cancel")}</p>
                </div>
                <div
                  className="d-flex gap-2 align-items-center justify-content-center cursor-pointer"
                  onClick={() => handleSubmit()}
                >
                  <img src={SaveIcon} className="mb-3" alt="icon" />
                  <p className="edit-details">{t("Save")}</p>
                </div>
              </div>
            )}
          </div>
          <Box className="d-flex justify-content-between">
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
              {isEditPersonDetails ? (
                <DisplayFIeldLabel title={t("First Name")} />
              ) : (
                <DisplayFIeldLabel title={t("First Name")} isMandatory={true} />
              )}
              <Input
                value={
                  activeMemberDetails?.name &&
                  formattedName({ type: "input", isFirstName: true })
                }
                className="input-box input-box-profile-modal"
                onChange={(e) => handleUpdateDetails("fname", e.target.value)}
                isDisabled={isEditPersonDetails}
                style={{background: isEditPersonDetails ?"#ECEFF1":""}}
                noShadow={true}
              />
              {errors?.fname && (
                <ErrorMessage className="pt-1">{t(errors.fname)}</ErrorMessage>
              )}
            </div>
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
              {isEditPersonDetails ? (
                <DisplayFIeldLabel title={t("Last Name")} />
              ) : (
                <DisplayFIeldLabel title={t("Last Name")} isMandatory={true} />
              )}
              <Input
                noShadow={true}
                value={
                  activeMemberDetails?.name &&
                  formattedName({ type: "input", isFirstName: false })
                }
                className="input-box input-box-profile-modal"
                onChange={(e) => handleUpdateDetails("lname", e.target.value)}
                isDisabled={isEditPersonDetails}
                style={{background: isEditPersonDetails ?"#ECEFF1":""}}
              />
              {errors?.lname && (
                <ErrorMessage className="pt-1">{t(errors.lname)}</ErrorMessage>
              )}
            </div>
          </Box>
          <Box className="d-flex justify-content-between">
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
              {isEditPersonDetails ? (
                <DisplayFIeldLabel title={t("E-mail")} />
              ) : (
                <DisplayFIeldLabel title={t("E-mail")} isMandatory={false} />
              )}
              <Input
                noShadow={true}
                value={activeMemberDetails?.emailAddress}
                style={{background: isEditPersonDetails ?"#ECEFF1":""}}
                className="input-box input-box-profile-modal"
                onChange={(e) =>
                  handleUpdateDetails("contact_email", e.target.value)
                }
                isDisabled={isEditPersonDetails}
              />
              {errors?.emailAddress && (
                <ErrorMessage className="pt-1">
                  {t(errors?.emailAddress)}
                </ErrorMessage>
              )}
            </div>
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
              {isEditPersonDetails ? (
                <DisplayFIeldLabel title={t("Contact Number")} />
              ) : (
                <DisplayFIeldLabel
                  title={t("Contact Number")}
                  isMandatory={true}
                />
              )}
              <Input
              style={{background: isEditPersonDetails ?"#ECEFF1":""}}
                noShadow={true}
                value={activeMemberDetails?.phoneNumber}
                countryCodes={true}
                countryCodeValue={activeMemberDetails?.countryCode}
                setCountryCode={(e) => handleUpdateDetails("country_code", e)}
                onChange={(e) =>
                  handleUpdateDetails("contact_phone", e.target.value)
                }
                border={
                  activeMemberDetails?.phoneNumber?.length
                    ? "1px solid #606734"
                    : null
                }
                placeholder="785-785-4644"
                className="input-box input-box-profile-modal"
                type="number"
                pattern="[0-9]"
                overflow="unset"
                isDisabled={isEditPersonDetails}
              />
              {errors?.phoneNumber && (
                <ErrorMessage className="pt-1">
                  {t(errors.phoneNumber)}
                </ErrorMessage>
              )}
              {errors?.countryCode && (
                <ErrorMessage className="pt-1">
                  {t(errors.countryCode)}
                </ErrorMessage>
              )}
            </div>
          </Box>
          <Box className="d-flex justify-content-between">
            <div  className="col-lg-6 input-width add-input-field-margin-profile-modal">
              {isEditPersonDetails ? (
                <DisplayFIeldLabel
                  title={
                    components?.canEditMember
                      ? t("Select Country")
                      : t("Country")
                  }
                />
              ) : (
                <DisplayFIeldLabel
                  title={
                    components?.canEditMember
                      ? t("Select Country")
                      : t("Country")
                  }
                  isMandatory={true}
                />
              )}
              <SelectBoxWrapper >
                <Select
                  size="middle"
                  value={activeMemberDetails?.country}
                  className={`input-box-profile-modal ${isEditPersonDetails ? "gray-profile-input-bg" : ""}`}
                  filterOption={false}
                  defaultValue={t("Select Country")}
                  onChange={(value) => {
                    handleUpdateDetails("country", value);
                    dispatch({
                      type: STORE_CITIES,
                      cities: [],
                    });
                  }}
                
                  style={{width: "100%", height: "auto"}}
                  dropdownStyle={{ zIndex: 2000 }}
                  options={customCountries}
                  disabled={isEditPersonDetails || !components?.canEditMember}
                >
                  {/* <Select.Option value="time">Time</Select.Option>
        <Select.Option value="date">Date</Select.Option> */}
                </Select>
              </SelectBoxWrapper>
              {errors?.country && (
                <ErrorMessage className="pt-1">
                  {t(errors.country)}
                </ErrorMessage>
              )}
            </div>
            {isFetchingCities ? (
              <div
                className="col-lg-6 input-width add-input-field-margin-profile-modal"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner />
              </div>
            ) : (
              <div
                className="col-lg-6 input-width add-input-field-margin-profile-modal "
                style={{}}
              >
                {isEditPersonDetails ? (
                  <DisplayFIeldLabel title={t("City")} />
                ) : (
                  <DisplayFIeldLabel title={t("City")} isMandatory={true} />
                )}
                <SelectBoxWrapper>
                  {/* <Select
                    size="middle"
                    value={activeMemberDetails?.city}
                    className="input-box-profile-modal"
                    defaultValue={t("Select City")}
                    onChange={(value) => handleUpdateDetails("city", value)}
                    dropdownStyle={{ zIndex: 2000 }}
                    style={{ width: "100%", fontWeight: 600 }}
                    options={cities}
                  /> */}
                  <ProfileModalCitySelection
                    defaultText={activeMemberDetails?.city || t("Select City")}
                    handleChangeUser={handleUpdateDetails}
                    activeMemberDetails={activeMemberDetails}
                    cities={cities}
                    isDisabled={isEditPersonDetails}
                  />
                </SelectBoxWrapper>
                {errors?.city && (
                  <ErrorMessage className="pt-1">{t(errors.city)}</ErrorMessage>
                )}
              </div>
            )}
          </Box>
          <Box className="d-flex justify-content-between">
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
              <DisplayFIeldLabel title={t("Postal Code")} isMandatory={false} />
              <Input
                noShadow={true}
                value={
                  activeMemberDetails?.pincode ||
                  activeMemberDetails?.postalCode ||
                  ""
                }
                className="input-box input-box-profile-modal"
                onChange={(e) => handleUpdateDetails("pincode", e.target.value)}
                isDisabled={isEditPersonDetails}
                style={{background: isEditPersonDetails ?"#ECEFF1":""}}
              />
              {errors?.pincode && (
                <ErrorMessage className="pt-1">
                  {t(errors.pincode)}
                </ErrorMessage>
              )}
            </div>
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
              <DisplayFIeldLabel
                title={t("Date of Birth")}
                isMandatory={false}
              />
              <input
              type="date"
              value={formatDobForInput(activeMemberDetails?.dob) || ''}
              onChange={(e) => handleUpdateDetails("dob", e.target.value)}
              className="input-box calendar"
             style={{background: isEditPersonDetails ?"#ECEFF1":"", boxShadow:'none'}}
              disabled={isEditPersonDetails}
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() - 18))
                  .toISOString()
                  .split("T")[0]
              }
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 100))
                  .toISOString()
                  .split("T")[0]
              }
            />
            {errors.dob && (
              <ErrorMessage className="pt-1">{t(errors.dob)}</ErrorMessage>
            )}
            </div>
          </Box>
          <Box className="d-flex justify-content-between">
            <div
              className="col-lg-12 input-width add-input-field-margin-profile-modal"
              style={{ width: "100%" }}
            >
              <DisplayFIeldLabel title={t("Address")} isMandatory={false} />
              <Input
                noShadow={true}
                value={activeMemberDetails?.address || ""}
                className="input-box input-box-profile-modal"
                onChange={(e) => handleUpdateDetails("address", e.target.value)}
                isDisabled={isEditPersonDetails}
                style={{background: isEditPersonDetails ?"#ECEFF1":""}}
              />
              {errors?.address && (
                <ErrorMessage className="pt-1">
                  {t(errors.address)}
                </ErrorMessage>
              )}
            </div>
          </Box>
          <Box className="d-flex justify-content-between">
            <div className="col-lg-6 input-width add-input-field-margin-profile-modal radio-group">
              <DisplayFIeldLabel title={t("Gender")} isMandatory={false} />
              {isEditPersonDetails && (
                <Input
                  noShadow={true}
                  value={activeMemberDetails?.gender}
                  className="input-box input-box-profile-modal text-capitalize"
                  onChange={(e) =>
                    handleUpdateDetails("gender", e.target.value)
                  }
                  isDisabled={isEditPersonDetails}
                  style={{background: isEditPersonDetails ?"#ECEFF1":""}}
                />
              )}
              {!isEditPersonDetails && (
                <div className="d-flex align-items-center gap-3 mt-3 ">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      checked={activeMemberDetails?.gender === "male"}
                      onChange={(e) =>
                        handleUpdateDetails("gender", e.target.value)
                      }
                    />
                    {t("Male")}
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      checked={activeMemberDetails?.gender === "female"}
                      onChange={(e) =>
                        handleUpdateDetails("gender", e.target.value)
                      }
                    />
                    {t("Female")}
                  </label>
                </div>
              )}
              {errors?.gender && (
                <ErrorMessage className="pt-1">
                  {t(errors?.gender)}
                </ErrorMessage>
              )}
            </div>
          </Box>
        </Box>
          <Box
            className="details-card"
            style={{
              pointerEvents: activeMemberDetails?.isDeactivated ? "none" : "",
            }}
          >
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <h5>
                  <img
                    src={membershipIcon}
                    alt="membership-icon"
                    style={{ marginRight: "8px" }}
                  />
                  {t("Membership Details")}
                </h5>
              </div>
              {userType !== 'viewer' && (components?.showMembershipInfo) && <div onClick={() => setShowChangeSub(true)}>
                {!showChangeSub && (
                  <div className="d-flex gap-1 align-items-center justify-content-center cursor-pointer">
                    <img src={editIcon} className="mb-3" alt="icon" />
                    <p className="edit-details">{t("Edit")}</p>
                  </div>
                )}
              </div>}
            </div>
            <Box className="d-flex justify-content-between">
              <div className="col-lg-6 input-width add-input-field-margin-profile-modal" style={{height: "auto"}}>
                <DisplayFIeldLabel
                  title={t("Payment Method")}
                  isEditPersonDetails={true}
                />
                <Select
                  size="middle"
                  value={activeMemberDetails?.paymentMode}
                  dropdownStyle={{ zIndex: 2000 }}
                  className="input-box-profile-modal"
                  disabled
                  defaultValue={t("Payment Method")}
                  onChange={(value) => {
                    handleUpdateDetails("paymentMode", value);
                  }}
                  style={{
                    width: "100%",
                    fontWeight: 600,
                    marginBottom: "16px",
                    height: "auto",
                    boxShadow:'none'
                  }}
                  options={getPaymentMethods()}
                />
              </div>
              <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
                <div className="d-flex align-items-center gap-2">
                  <DisplayFIeldLabel title={t("Membership")} />
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    style={{
                      background: "white",
                      padding: 0,
                      border: "1px solid #D9D9D9",
                    }}
                    overlay={infoPopover}
                  >
                    <img src={info} alt="info" style={{ cursor: "pointer" }} />
                  </OverlayTrigger>
                </div>
                <SelectBoxWrapper>
                  <Select
                    size="middle"
                    value={
                      activeMemberDetails?.activeSubscription
                        ? `${
                              activeMemberDetails?.activeSubscription?.plan_name
                          } - €${
                              activeMemberDetails?.activeSubscription?.amount
                          }`
                        : t("Free Subscription")
                    }
                    dropdownStyle={{ zIndex: 2000 }}
                    className="input-box-profile-modal"
                    // disabled={activeMemberDetails?.isMobileOnBoarded}
                    disabled
                    defaultValue={t("Select Plan")}
                    onChange={(value) => {
                      handleUpdateDetails("subscription_plan_id", value);
                    }}
                    style={{ width: "100%", fontWeight: 600, height: "auto" }}
                    options={optionsPlan()}
                  />
                </SelectBoxWrapper>
              </div>
            </Box>
            {activeMemberDetails?.customerAccountName ||
            activeMemberDetails?.customerIBAN ? (
              <Box className="d-flex justify-content-between">
                {activeMemberDetails?.customerAccountName && (
                  <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
                    <DisplayFIeldLabel title={t("Customer Account name")} />
                    <input
                      value={activeMemberDetails?.customerAccountName}
                      type={"text"}
                      // onFocus={handleFocusCustName}
                      // onBlur={handleBlurCustName}
                      onChange={(e) =>
                        handleUpdateDetails("customer_acc_name", e.target.value)
                      }
                      className="input-box input-box-profile-modal"
                      disabled
                      style={{background: "#ECEFF1"}}
                    />
                  </div>
                )}
                {activeMemberDetails?.customerIBAN && (
                  <div className="col-lg-6 input-width add-input-field-margin-profile-modal">
                    <DisplayFIeldLabel title={t("Customer IBAN")} />
                    <input
                      value={
                        activeMemberDetails?.customerIBAN
                          ? activeMemberDetails.customerIBAN.length > 5
                            ? `${"•".repeat(
                                activeMemberDetails.customerIBAN.length - 5
                              )}${activeMemberDetails.customerIBAN.slice(-5)}`
                            : activeMemberDetails.customerIBAN
                          : ""
                      }
                      type="text"
                      // onFocus={handleFocusOne}
                      // onBlur={handleBlur}
                      disabled
                      onChange={(e) =>
                        handleUpdateDetails("customer_iban", e.target.value)
                      }
                      className="input-box input-box-profile-modal"
                      style={{background: "#ECEFF1"}}
                    />
                  </div>
                )}
              </Box>
            ) : null}
            <Box className="d-flex justify-content-between">
              <div
                className="col-lg-6 input-width add-input-field-margin-profile-modal"
                style={{
                  display: activeMemberDetails?.pdf_registeration_link
                    ? "block"
                    : "none",
                }}
              >
                <DisplayFIeldLabel title={t("Standalone form")} />
                <a
                  className="pdf-register-link d-flex justify-content-center align-items-center gap-1"
                  href={
                    `https://${activeMemberDetails?.pdf_registeration_link}` ||
                    ""
                  }
                  download="download.pdf"
                  target="_blank"
                  rel="noreferrer"
                  id="pdfDownloadLink"
                >
                  <img src={download} alt="download-icon" />
                  PDF
                </a>
              </div>
            </Box>
          </Box>
        <div className="details-card">
          <div className="d-flex align-items-baseline">
            <Icon iconName="payment" mr="10px" />
            <h5>{t("Payment History")}</h5>
          </div>
          <div className="d-flex justify-content-between member_ship">
            <div className="input-width add-input-field-margin-profile-modal">
              <DisplayFIeldLabel title={t("Total Received Payments")} />
              <h6 className="headingSix m-0">
                {activeMemberDetails?.successPaymentsTotal.toFixed(2)}
              </h6>
            </div>
            <div className="input-width add-input-field-margin-profile-modal">
              <DisplayFIeldLabel title={t("Outstanding Payments")} />
              <h6 className="headingSix m-0">
                {activeMemberDetails?.pendingPaymentsTotal.toFixed(2)}
              </h6>
            </div>
          </div>
          <div className="input-width add-input-field-margin-profile-modal">
            <DisplayFIeldLabel
              classTitle={"label-missed-payments"}
              title={t("Previous Missed Payments")}
            />
            <h6 className="headingSix m-0">
              {activeMemberDetails?.missedPaymentsTotal.toFixed(2)}
            </h6>
          </div>
          <div className="month-day pt-3">
            {MonthData &&
              MonthData.map((item) => (
                <div>
                  <h6>{t(item?.name)}</h6>
                  {renderPaymentStatus(activeMemberDetails, item?.number)}
                </div>
              ))}
          </div>
        </div>
        {user?.role === "admin" ? (
          <div className="details-card">
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <Icon iconName="markMissedIcon" mr="10px" />
                <h5>{t("Mark Missed Payment as Paid")}</h5>
              </div>
              {missedPayments.length > 0 && (
                <>
                  {isEditMarkPayment && (
                    <div
                      className="d-flex gap-1 align-items-center justify-content-center cursor-pointer"
                      onClick={() => setIsEditMarkPayment(false)}
                    >
                      <img src={editIcon} className="mb-3" alt="icon" />
                      <p className="edit-details">{t("Edit")}</p>
                    </div>
                  )}
                  {!isEditMarkPayment && (
                    <div className="d-flex gap-3 align-items-center justify-content-center">
                      <div
                        className="d-flex gap-2 mx-3 align-items-center justify-content-center cursor-pointer"
                        onClick={() => setIsEditMarkPayment(true)}
                      >
                        <img src={CancelIcon} className="mb-3" alt="icon" />
                        <p className="cancel-details">{t("Cancel")}</p>
                      </div>
                      <div
                        className="d-flex gap-2 align-items-center justify-content-center cursor-pointer"
                        onClick={() => setShowMarkModal(true)}
                      >
                        <img src={SaveIcon} className="mb-3" alt="icon" />
                        <p className="edit-details">{t("Save")}</p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="member_ship">
              {missedPayments.length === 0 ? (
                <DisplayFIeldLabel title={t("All payments up to date!")} />
              ) : (
                <div>
                  <div>
                    <p className="month-label">
                      {t(
                        "Select the missed months to update the payment status"
                      )}
                    </p>
                  </div>
                  <div style={{ display: "block", marginTop: "30px" }}>
                    <div className="d-flex gap-3">
                      {missedMonths.map((month) => (
                        <label key={month} className="d-flex mb-1 gap-2">
                          <input
                            type="checkbox"
                            style={{  height:'15px', width:'15px' }}
                            className="custom-checkbox missed-payment-checkbox"

                            checked={
                              isEditMarkPayment
                                ? null
                                : selectedMonths.includes(month)
                            }
                            disabled={isEditMarkPayment}
                            onChange={() => handleCheckboxChange(month)}
                          />
                          <span className="month-paid">{` ${month}`}</span>
                        </label>
                      ))}
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      {selectedMonths.length > 0 && !isEditMarkPayment ? (
                        <div>
                          <p className="italic-text-s m-0">
                            {t(
                              `You are marking ${selectedMonths.join(
                                ", "
                              )} as paid.`
                            )}
                          </p>
                        </div>
                      ) : (
                        <p className="italic-text-s m-0">
                          {t("None selected")}{" "}
                        </p>
                      )}
                    </div>
                    {/* <Box display="flex" justifyContent="flex-start" mt="20px">
                <Box>
                  <Button
                    type={
                      selectedMonths.length > 0
                        ? "outlineColor"
                        : "disabledOutlineColor"
                    }
                    text={t("Cancel")}
                    borderRadius="66px"
                    minWidth="100px"
                    height="25px"
                    mb={4}
                    onClick={() => onHide(null, false)}
                  />
                </Box>
                <Box ml="15px">
                  <Button
                    type={selectedMonths.length > 0 ? "primary" : "disabled"}
                    text={t("Mark as Paid ")}
                    borderRadius="66px"
                    minWidth="100px"
                    mb={4}
                    disabled={selectedMonths.length < 1}
                    height="25px"
                    onClick={() => setShowMarkModal(true)}
                  />
                </Box>
              </Box> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="details-card">
            <div className="d-flex">
              <Icon iconName="historyMsg" mr="10px" />
              <h5>{t("REMINDER HISTORY")}</h5>
            </div>

            <div className="d-flex">
              <div className="sent-msg label-sent-msg mb-2">
                <label style={{ fontSize: "13px", minWidth: "130px" }}>
                  {t("Sent On")}
                </label>
              </div>
              <div className="message label-message mb-2">
                <label style={{ paddingRight: "40px", fontSize: "13px" }}>
                  {t("Message")}
                </label>
              </div>
            </div>
            {reminder_history?.length > 0 &&
              reminder_history?.map((reminder, index) => (
                <div className="d-flex">
                  <div className="sent-msg date-container">
                    <h3>
                      {dayjs(new Date(reminder.created_at)).format("DD MMM YY")}
                    </h3>
                    {index !== reminder_history.length - 1 && (
                      <div className="vertical-dotted-line"></div>
                    )}
                  </div>
                  <div className="message  label-msg">
                    <label>{reminder.compiled_text}</label>
                  </div>
                </div>
              ))}
          </div>
        )}
        {/* <Box
          className="details-card"
          display="flex"
          justifyContent="space-between"
        >
          <Box>
            <Button
              type="outlineColor"
              text={t("Cancel")}
              borderRadius="66px"
              minWidth="200px"
              height="50px"
              mb={4}
              onClick={() => onHide(null, false)}
            />
          </Box>
          <Box ml="15px">
            <Button
              type={
                activeMemberDetails?.isMobileOnBoarded || !isDetailsUpdated
                  ? "disabled"
                  : "primary"
              }
              text={t("Save Details")}
              borderRadius="66px"
              minWidth="200px"
              mb={4}
              disabled={
                activeMemberDetails?.isMobileOnBoarded || !isDetailsUpdated
              }
              height="50px"
            />
          </Box>
        </Box> */}
        {userType !== "viewer" && <span role="button" className="delete-user-btn" onClick={()=> setIsDeleteMember(true)}>
          <Icon iconName="delete" stroke="#FE1717"/>
          Permanently delete user
          </span>}
      </Box>
      <DefaultModal
        show={isDisable}
        onHide={() => setIsDisable(false)}
        className="congrats-modal"
        style={{ paddingRight: "0px" }}
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
        {activeMember?.isDeactivated ? (
          <DisableMemberModal
            text={t("Do you want to enable the user?")}
            handleDelete={() => updateStatus()}
            show={isDisable}
            setshow={setIsDisable}
            setComment={setComment}
            comment={comment}
            isProfileModal={true}
            isShowReason={false}
          />
        ) : (
          <DisableMemberModal
            text={t("Do you want to disable the user?")}
            handleDelete={() => updateStatus()}
            show={isDisable}
            setshow={setIsDisable}
            setComment={setComment}
            comment={comment}
            isProfileModal={true}
            isShowReason={true}
          />
        )}
      </DefaultModal>
      <DefaultModal
        show={showChangeSub}
        onHide={() => setShowChangeSub(false)}
        className="congrats-modal"
        style={{ paddingRight: "0px" }}
        centered={true}
        showHeader={false}
        size="large"
        showFooter={false}
      >
        <div className="d-flex justify-content-between">
          <div></div>
          <div
            className="cursor-pointer"
            onClick={() => setShowChangeSub(false)}
          >
            <img src={crossIcon} alt="cross" />
          </div>
        </div>
        <div className="congrats-screen" style={{ paddingInline: "20px" }}>
          {/* <img src="https://ik.imagekit.io/rzlzf40okya/elixir/diseble.svg" /> */}
          <Box>
            <h4 style={{ fontWeight: 700 }}>{t("Edit subscription")}</h4>
            <div style={{ marginBottom: "16px" }}>
              <DisplayFIeldLabel title={t("Payment Method")} />
              <Select
                size="middle"
                value={activeMemberDetails?.paymentMode}
                dropdownStyle={{ zIndex: 2000 }}
                className="input-box-profile-modal"
                // disabled={activeMemberDetails?.isMobileOnBoarded}
                defaultValue={t("Payment Method")}
                onChange={(value) => {
                  handleUpdateDetails("paymentMode", value);
                }}
                style={{ width: "100%", fontWeight: 600, height: "auto", boxShadow:'none' }}
                options={getPaymentMethods()}
              />
              {editSubscriptionErrors?.paymentMode && (
                <ErrorMessage className="pt-1">
                  {t(editSubscriptionErrors.paymentMode)}
                </ErrorMessage>
              )}
            </div>
            <div style={{ marginBottom: "16px" }}>
              <DisplayFIeldLabel title={t("Membership")} />
              <Select
                size="middle"
                value={
                  activeMemberDetails?.subscription_plan_id
                    ? `${
                        getSelectedPlan(
                          activeMemberDetails?.subscription_plan_id
                        )?.plan_name
                      } - €${
                        getSelectedPlan(
                          activeMemberDetails?.subscription_plan_id
                        )?.amount
                      }`
                    : t("Free Subscription")
                }
                dropdownStyle={{ zIndex: 2000 }}
                className="input-box-profile-modal"
                // disabled={activeMemberDetails?.isMobileOnBoarded}
                defaultValue={t("Select Plan")}
                onChange={(value) => {
                  handleUpdateDetails("subscription_plan_id", value);
                }}
                style={{ width: "100%", fontWeight: 600, height: "auto" }}
                options={optionsPlan()}
              />
              {editSubscriptionErrors.subscription_plan_id && (
                <ErrorMessage className="pt-1">
                  {t(editSubscriptionErrors.subscription_plan_id)}
                </ErrorMessage>
              )}
            </div>
          </Box>
          {activeMemberDetails?.paymentMode === "automatic" && (
            <Box
              className="d-flex justify-content-between"
              style={{ flexWrap: "wrap" }}
            >
              <div
                className="col-lg-12 input-width "
                style={{ position: "relative" }}
              >
                <DisplayFIeldLabel
                  title={t("Customer Account name")}
                  isMandatory={true}
                />
                <input
                  value={activeMemberDetails?.customerAccountName}
                  type={isFocusedCustName ? "text" : "password"}
                  // onFocus={handleFocusCustName}
                  // onBlur={handleBlurCustName}
                  onChange={(e) =>
                    handleUpdateDetails("customerAccountName", e.target.value)
                  }
                  className="input-box input-box-profile-modal"
                />
                <Icon
                  iconName="eye"
                  onClick={handleFocusCustName}
                  color="grey"
                  style={{
                    position: "absolute",
                    bottom: editSubscriptionErrors.customerAccountName
                      ? "42px"
                      : "20px",
                    right: "10px",
                  }}
                />
                {editSubscriptionErrors.customerAccountName && (
                  <ErrorMessage className="pt-1">
                    {t(editSubscriptionErrors.customerAccountName)}
                  </ErrorMessage>
                )}
              </div>
              <div
                style={{
                  display: "block",
                  width: "100%",
                  gap: "5px",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <div
                  className="col-12"
                  style={{ position: "relative", width: "100%" }}
                  // style={{ marginLeft: "10px" }}
                >
                  <DisplayFIeldLabel
                    title={t("Customer IBAN")}
                    isMandatory={true}
                  />
                  <input
                    value={activeMemberDetails?.customerIBAN}
                    type={isFocusedIBANOne ? "text" : "password"}
                    // onFocus={handleFocus}
                    // onBlur={handleBlur}
                    onChange={(e) =>
                      handleUpdateDetails("customerIBAN", e.target.value)
                    }
                    className="input-box input-box-profile-modal"
                  />
                  <Icon
                    iconName="eye"
                    color="grey"
                    onClick={handleFocusOne}
                    style={{
                      position: "absolute",
                      bottom:
                        editSubscriptionErrors.customerIBAN || ibanError
                          ? "42px"
                          : "20px",
                      right: "10px",
                    }}
                  />
                  {editSubscriptionErrors.customerIBAN && (
                    <ErrorMessage className="pt-1">
                      {t(editSubscriptionErrors.customerIBAN)}
                    </ErrorMessage>
                  )}
                  {ibanError && (
                    <ErrorMessage className="pt-1">{t(ibanError)}</ErrorMessage>
                  )}
                </div>
                <div
                  className="col-12 pt-2 input-width"
                  style={{ position: "relative" }}
                  // style={{ marginLeft: "10px" }}
                >
                  <DisplayFIeldLabel
                    title={t("Repeat") + t("Customer IBAN")}
                    isMandatory={true}
                  />
                  <input
                    value={compareIban}
                    type={isFocusedIBANTwo ? "text" : "password"}
                    onFocus={() => {
                      setIsCompareIbanError(false);
                      setIbanError("");
                    }}
                    // onBlur={handleBlur}

                    onChange={(e) => setCompareIban(e.target.value)}
                    className="input-box input-box-profile-modal"
                  />
                  <Icon
                    iconName="eye"
                    onClick={handleFocusTwo}
                    color="grey"
                    style={{
                      position: "absolute",
                      bottom: isCompareIbanError ? "43px" : "20px",
                      right: "10px",
                    }}
                  />
                  {isCompareIbanError && (
                    <ErrorMessage className="pt-1">
                      {t("IBAN not matching")}
                    </ErrorMessage>
                  )}
                </div>
              </div>
            </Box>
          )}
          {/* <Label color="#7E7E7E">{text}</Label> */}
          <div className="d-flex items-left">
            <input
              type="checkbox"
              className="custom-checkbox"
              style={{height:'20px', width:"20px"}}
              checked={acknowledgeEditSubscription}
              onChange={(e) => setAcknowledgeEditSubscription(e.target.checked)}
            />
            <span style={{ marginLeft: "8px" }}>
              {t("This change is acknowledged by the Member")}
            </span>
            <span style={{ color: "#FE1717", marginLeft: "3px" }}>*</span>
          </div>
          <p>
            {editSubscriptionErrors.editSubscriptionAcknowledge && (
              <ErrorMessage className="pt-1">
                {t(editSubscriptionErrors.editSubscriptionAcknowledge)}
              </ErrorMessage>
            )}
          </p>
          <div className="d-flex justify-content-around mt-3 mb-3 pb-1">
            <button className="prev-bt" onClick={() => setShowChangeSub(false)}>
              {t("Cancel")}
            </button>
            <button className="fill-bt" onClick={handleChangeSubscription}>
              {t("Save")}
            </button>
          </div>
        </div>
      </DefaultModal>
      <DefaultModal
        show={isDeleteMember}
        onHide={() => setIsDeleteMember(false)}
        className="congrats-modal"
        style={{ paddingRight: "0px" }}
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
          <DisableMemberModal
            text={t("Are you sure you want to permanently delete this user?")}
            handleDelete={handleDeleteMember}
            show={isDeleteMember}
            setshow={setIsDeleteMember}
            setComment={setComment}
            comment={comment}
            successText={isDeletingMember?"Deleting ...":"Delete Member"}
            isProfileModal={true}
          />
      </DefaultModal>
      <Modal
        title="Payment Amount for the selected Months"
        zIndex={11000}
        open={showMarkModal}
        onOk={handleMarkPaid}
        okText="Confirm"
        okButtonProps={{
          style: {
            background: " #D0004B",
            color: "#ffffff",
            cursor: "pointer",
          },
        }}
        onCancel={() => setShowMarkModal(false)}
      >
        <p style={{ fontSize: "36px", fontWeight: "500" }}>
          {selectedMissedTotal.toFixed(2)}
        </p>
      </Modal>
      <Modal
        open={isDisableMessageModal}
        zIndex={11000}
        onCancel={() => setIsDisableMessageModal(false)}
        cancelButtonProps={{
          style: { display: "none" }
        }}
        onOk={() => setIsDisableMessageModal(false)}
        okButtonProps={{
          style: {
            background: " #D0004B",
            color: "#ffffff",
            cursor: "pointer",
          },
        }}
        className="congrats-modal"
        style={{ paddingRight: "0px" }}
        centered={true}
        size=""
      >
        <h6>{t(disableMessage)}</h6>
      </Modal>
    </Box>
  );
};

function DisplayFIeldLabel({ title, isMandatory, classTitle }) {
  return (
    <Label
      style={{
        fontSize: "16px",
        fontFamily: "Raleway",
        fontWeight: 400,
        color: "#7E7E7E",
        marginBottom: "5px",
      }}
      className={classTitle || ""}
    >
      {title}
      {isMandatory ? (
        <span style={{ color: "#FE1717", marginLeft: "3px" }}>*</span>
      ) : (
        ""
      )}
    </Label>
  );
}
export default ProfileModal;
